import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router';
import { LoginPage } from './auth/login-page.js';
import { RegisterPage } from './auth/register-page.js';
import { useSession } from './auth/session.js';
import { AddContentPage } from './catalog/add-content-page.js';
import { CollectionPage } from './catalog/collection-page.js';
import { ImportSourcePage } from './catalog/import-source-page.js';
import { LibraryPage } from './catalog/library-page.js';
import { ChildrenPage } from './children/children-page.js';
import { DevicesPage } from './devices/devices-page.js';
import { PairDevicePage } from './devices/pair-device-page.js';
import { OverviewPage } from './overview/overview-page.js';
import { ScreenTimePage } from './screen-time/screen-time-page.js';
import { WatchingItemPage } from './watching/watching-item-page.js';
import { WatchingPage } from './watching/watching-page.js';

/**
 * Routes.
 *
 * The signed-in area is a single guarded branch rather than a check inside each
 * screen: a screen that forgets the check is a screen that renders a parent's
 * data to whoever opened the tab.
 */
const RequireSession = () => {
  const session = useSession();
  return session === null ? <Navigate to="/login" replace /> : <Outlet />;
};

export const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route element={<RequireSession />}>
        <Route index element={<OverviewPage />} />
        <Route path="/children" element={<ChildrenPage />} />
        <Route path="/children/:childId/screen-time" element={<ScreenTimePage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/library/add" element={<AddContentPage />} />
        <Route path="/library/import" element={<ImportSourcePage />} />
        <Route path="/library/collections/:collectionId" element={<CollectionPage />} />
        <Route path="/watching" element={<WatchingPage />} />
        <Route path="/watching/items/:contentItemId" element={<WatchingItemPage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/devices/pair" element={<PairDevicePage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
